"use strict";

require("core-js/modules/es6.array.sort");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var Pagination_1 = require("../../atoms/Pagination");

var ComplexTable_1 = require("./ComplexTable");
/**
 * This is a stateful version of `<ComplexTable>`. PLEASE NOTE: Unlike the Stateful variants of formfield components
 * that are meant to be implemented for non-React-Environment (e.g. ShowCases), this variant of the `ComplexTable` is meant for React Logic also.
 * The `ComplexTable.Stateful` adds a sorting functionality, so you do not have necessarily to maintain the contents of the table and the sorting
 * algorithm in your wrapping component. For the sorting functionality, you can also define a sorting comparator for each column.
 * @visibleName ComplexTable.Stateful
 */


var ComplexTableStateful =
/** @class */
function (_super) {
  __extends(ComplexTableStateful, _super);

  function ComplexTableStateful() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      sortColumn: _this.props.defaultSortColumn,
      isSortedAscending: _this.props.defaultIsSortedAscending,
      tableBodyData: _this.props.tableBodyData,
      isMobile: ComplexTableStateful.mobileViewports.includes(utils_1.WindowEvents.getViewportSize()),
      activePage: 1
    }; // DOWN-Arrow = Sort ASCENDING = A..Z, 0..9, earliest date .. latest date  !!
    // at first click, the sorting shall be ascending (down arrow)

    _this.onStatefulTableHeadingClick = function (column, columnName, isSortAscending, e) {
      // Make a copy of the table data and sort it in an immutable way
      if (_this.props.columnProperties[column].isSortable) {
        _this.setState({
          sortColumn: column,
          isSortedAscending: isSortAscending
        });

        if (_this.props.onHeadingClick) {
          _this.props.onHeadingClick(column, columnName, isSortAscending, e);
        }
      }
    };

    _this.defaultSortComparator = function (a, b) {
      return a > b && 1 || a < b && -1 || 0;
    };

    return _this;
  }

  ComplexTableStateful.prototype.render = function () {
    var _this = this; // Sorting at render time -> should not be inperfomant
    // TableBodyData is not managed by this component, but by the parent component.


    var sortedTableBodyData = this.props.tableBodyData.slice();
    var sortColumn = this.state.sortColumn;

    if (sortColumn !== undefined && this.props.columnProperties[this.state.sortColumn].isSortable) {
      // const sortedTableData = this.state.tableBodyData.slice();
      var sortComparator = this.props.columnProperties[this.state.sortColumn].sortComparator || this.defaultSortComparator;
      this.sortRows(this.state.sortColumn, sortComparator, this.state.isSortedAscending, sortedTableBodyData);
    }

    var numPages = Math.max(1, Math.ceil(this.props.tableBodyData.length / this.props.numRowsPerPage));
    var paginatedTableBodyData = sortedTableBodyData.slice((this.state.activePage - 1) * this.props.numRowsPerPage, this.state.activePage * this.props.numRowsPerPage);
    return React.createElement(React.Fragment, null, React.createElement(ComplexTable_1.ComplexTable, {
      columnProperties: this.props.columnProperties,
      tableBodyData: this.props.numRowsPerPage === undefined ? sortedTableBodyData : paginatedTableBodyData,
      onHeadingClick: this.onStatefulTableHeadingClick,
      onBodyRowClick: this.props.onBodyRowClick,
      sortColumn: this.state.sortColumn,
      isSortedAscending: this.state.isSortedAscending
    }), this.props.numRowsPerPage !== undefined && React.createElement(Pagination_1.Pagination, {
      numPages: numPages,
      activePage: Math.min(this.state.activePage, numPages),
      onClick: function onClick(page) {
        return _this.setState({
          activePage: page
        });
      }
    }));
  };

  ComplexTableStateful.prototype.sortRows = function (column, sortComparator, isSortAscending, data) {
    data.sort(function (row1, row2) {
      var result = sortComparator(row1.rowData[column], row2.rowData[column]);
      result = isSortAscending ? result : -result;
      return result;
    });
  };

  ComplexTableStateful.mobileViewports = ["sm", "xs"];
  return ComplexTableStateful;
}(React.PureComponent);

exports.ComplexTableStateful = ComplexTableStateful;